import styled from 'styled-components';

const Error403Wrapper = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
`;

export { Error403Wrapper };